import React from 'react';

function Message(props) {
    return (
        <div className='container-fluid mt-3 px-3'>
            <div className="col-lg-12 e-card pt-3 px-5">
                <p>{props.value}</p>
            </div>
        </div>
    );
}

export default Message;
